import { createFileRoute } from '@tanstack/react-router'
import { BusinessSettingsScreen } from '@/features/business/routes/business-settings-screen'

export const Route = createFileRoute('/settings/business')({ component: BusinessSettingsScreen })
